import { IUrlInformation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import { FILTER_TYPE } from "constant/product-filter.action";
import { IOrderedItemView } from "interfaces/session/ShoppingCart";
import { isKit } from "util/product/is-kit";

export function getTotalFilters(t, query: any, urlInformation: IUrlInformation, selectedVehicle: any, innerQuery = {}) {
  const totalFilters = { ...urlInformation, ...query, ...innerQuery };
  const keysToRemove = [
    "pathname", "bannerImageUrl", "categoryDescription",
    "categoryDisplayableTitle", "postalCode", "url", "nextPageType",
  ];
  const filterMap = Object.keys(totalFilters)
    .sort()
    .reduce((acc, filterKey) => {
      // keys which are not supposed to render for filter summary.
      if (!keysToRemove.includes(filterKey)) {
        acc[filterKey] = totalFilters[filterKey];
      }
      return acc;
    }, {});

  if (filterMap.t3) {
    filterMap.tier3 = filterMap.t3;
  }

  if (filterMap.t2) {
    filterMap.tier2 = filterMap.t2;
  }

  if (filterMap.t1) {
    filterMap.tier1 = filterMap.t1;
  }

  if (filterMap.t0) {
    filterMap.tier0 = filterMap.t0;
  }

  if (filterMap.availability || filterMap[FILTER_TYPE.AVAILABILITY]) {
    // Store availabilities as array
    if (typeof filterMap[FILTER_TYPE.AVAILABILITY] === "string") {
      filterMap[FILTER_TYPE.AVAILABILITY] = [filterMap[FILTER_TYPE.AVAILABILITY]];
    } else {
      filterMap[FILTER_TYPE.AVAILABILITY] = filterMap.availability || filterMap[FILTER_TYPE.AVAILABILITY];
    }
  }

  if (filterMap.priceRanges) {
    filterMap.prices = filterMap.priceRanges;
  }

  // set default filters
  if (!filterMap[FILTER_TYPE.AVAILABILITY]) {
    filterMap[FILTER_TYPE.AVAILABILITY] = [t("In Stock")];
  }
  if (filterMap[FILTER_TYPE.AVAILABILITY] && filterMap[FILTER_TYPE.AVAILABILITY].length === 0) {
    filterMap[FILTER_TYPE.AVAILABILITY] = [t("In Stock")];
  }
  if (!filterMap[FILTER_TYPE.FITMENT] && urlInformation.year) {
    filterMap[FILTER_TYPE.FITMENT] = [t("Vehicle Specific")];
  }

  if (query.tier0 === "tools-&-equipment" && urlInformation.year) {
    filterMap[FILTER_TYPE.FITMENT] = [t("Vehicle Specific"), t("Universal Fitment")];
  }

  if (!filterMap.pageNumber) {
    filterMap.pageNumber = 1;
  }

  if (!filterMap.sortBy) {
    filterMap.sortBy = "relevance";
  }

  if (selectedVehicle && selectedVehicle.engine) {
    filterMap.engine = selectedVehicle.engine || null;
  }

  return filterMap;
}

export const getSeason = (product: IOrderedItemView) => {
  const { extendedDescription, productSpecifications } = product;
  const { season } = extendedDescription;
  if (isKit(product)) {
    const seasonProduct = extendedDescription.components.find((component: any) => component.extendedDescription?.season);
    return seasonProduct ? seasonProduct.extendedDescription.season : season;
  }
  return productSpecifications?.season;
};
